import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const BooleanDefaultValueField = ({ value, onChange }) => {
    const Options = [
        "True",
        "False"
    ];

    const handleChange = (value) => {
        const e = {
            target: {
                value: value === "True" ? true : false,
                name: "defaultValue"
            }
        };
        onChange(e);
    }
    
    return (
        <DropDownList
            className="form-control-custom text-capitalize"
            name="defaultValue"
            value={value ? "True" : "False"}
            data={Options}
            onChange={(e) => handleChange(e.target.value)}
        />
    );
};

export default BooleanDefaultValueField;